import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getWorkflowStart } from 'action-creators/payway/workflowStart';
import { setCurrentPBI } from 'action-creators/payway/currentPayment/currentPBI';
import { hideEpg } from 'containers/Player/actions/optionButtons/epgButton.actions';
import { checkIfProtectPaymentIsActive } from 'containers/EPG/actions/channelBlocker/blocker.actions';
import { GetRegion } from 'constants.js';
import { hideGrid } from 'containers/Player/actions/optionButtons/gridButton.actions';
import ClaroUrlBuilder from 'utils/ClaroUrlBuilder';
import { hideEpgTransactions } from '../../actions/epgTransactions/epgTransactions.actions';
import { getTranslation } from '../../../../utils/getTranslation';
import { pushGTMEvent } from '../../utils/analytics';
import {
  createSearchParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { useEpgTransactions } from './hooks/useEpgTransactions';
import { getActionPaymentLink } from 'containers/Vcard/utils/redirect';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { clearPurchaseButtonInfo } from 'action-creators/payway/purchaseButtonInfo';
import './SingleOfferScreen.scss';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';
import { MultilineText } from 'utils/renderMultilineText';
import { PlayerContext } from 'containers/Player/context/PlayerContext';

const SingleOfferScreen = ({ wfscleared }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const { liveVideoTagRef } = useContext(PlayerContext);
  const translations = useSelector(state => state.translations);

  const assets = useSelector(state => state.asset);
  const pbi = useSelector(state => state.payway.purchaseButtonInfo);
  const workflowStart = useSelector(state => state.payway.workflowStart);
  const user = useSelector(state => state.user);

  const keyword =
    useSelector(state => state.search.searchResults.keyword) || '1';
  const isInPlayer = location?.pathname?.includes('watch');
  const { data: eventData } = useSelector(
    state => state.Player.EpgTransactions.epgTransactions,
  );
  const [planClicked, setPlanClicked] = useState(null);
  const { handleExitOrCancel } = useEpgTransactions();
  const claroLiteConfig = useSelector(
    selectMetadataKeyByRegion('cv_advertising_config'),
  );
  const isFreemiumUserNotLogged =
    user.userType === 'ANONYMOUS' && claroLiteConfig?.enable;

  const pushBeginCheckoutEvent = plan => {
    const gtmEventInfo = {
      event: 'begin_checkout',
      item_id: plan?.offerid,
      item_name: plan?.producttype.toLowerCase(),
      item_category: 'canal tv',
      item_category_2: 'no aplica',
      item_category_3:
        plan?.oneoffertype === 'subscrition'
          ? `por suscripcion${
              plan?.family === 'clarovideo' ? '' : ` ${plan?.family}`
            }`
          : '',
      item_category_4: 'no aplica',
      item_brand: plan?.family,
      item_list_name: 'player tv',
      price: plan?.price,
      quantity: '1',
    };
    pushGTMEvent(gtmEventInfo);
  };

  const { group_id } = pbi.data;
  searchParams.set('groupId', group_id);

  const plan = pbi?.data?.listButtons?.button?.[0];

  const { producttype, currency, price } = plan || {};

  const title = getTranslation(
    `Transaccionales_ContratacionCanalesUnica_TextoTitulo`,
    translations,
  );
  const logo =
    assets[`Transaccionales_ContratacionCanalesUnica_LogoAddon_${producttype}`];

  const priceText = `${currency}${price}`;

  const periodicity = getTranslation(
    `Transaccionales_ContratacionCanalesUnica_TextoTemporalidad_${producttype}`,
    translations,
  );

  const tax = getTranslation(
    `Transaccionales_TextoImpuestos_${producttype}`,
    translations,
  );
  const offer = getTranslation(
    `Transaccionales_ContratacionCanalesUnica_TextoOferta_${producttype}`,
    translations,
  );
  const promoMessage = getTranslation(
    `Transaccionales_ContratacionCanalesUnica_TextoPromocion_${producttype}`,
    translations,
  );
  const whatIncludes = getTranslation(
    `Transaccionales_ContratacionCanalesUnica_TextoBotonIncluye_${producttype}`,
    translations,
  );
  const colorPromotion =
    getTranslation('Color_ColorTextoPromocion', translations) || '#00a9ff';

  const bgColorWhatIncludes =
    getTranslation('Color_ColorQueIncluye', translations) || '#ecaf2a';

  const bgColorContract =
    getTranslation('Color_ColorPrimario', translations) || '#981c15';

  const bgColorCancel =
    getTranslation('Color_ColorSecundario', translations) || '#2e303d';

  const contract = getTranslation(
    `Transaccionales_ContratacionCanalesUnica_TextoBotonPrimarioContratar`,
    translations,
  );

  const cancel = getTranslation(
    `Transaccionales_ContratacionCanalesUnica_TextoBotonSecundarioCancelar`,
    translations,
  );
  useEffect(
    () => {
      if (workflowStart?.inProgress === false && wfscleared === true) {
        const link = getActionPaymentLink({
          userType: user.userType,
          claroAdEnabled: claroLiteConfig?.enable,
        });
        let params = {
          player_url: ClaroUrlBuilder?.player(group_id),
        };

        if (workflowStart.success) {
          if (user.userType === 'ANONYMOUS') {
            const urlVcard = `/${GetRegion()}/watch/${group_id}?anonymousUserComeFromTransaction=${
              isInPlayer ? '0' : keyword
            }`;
            params = {
              ...params,
              group_id,
              oneoffertype: planClicked?.oneoffertype,
              oneofferdesc: planClicked?.oneofferdesc,
              linkworkflowstart: planClicked?.linkworkflowstart,
              urlVcard,
            };
            const isBuyRentContent =
              plan?.oneoffertype === 'download_rent' ||
              plan?.oneoffertype === 'rent' ||
              plan?.oneoffertype === 'download_buy';

            if (isFreemiumUserNotLogged) {
              params.anonymousUser = 'true';
              localStorage.setItem('object_id', plan?.product_id);
              if (isBuyRentContent) {
                params.isBuyRentContent = 'true';
                localStorage.removeItem('object_id');
              }
            }
            dispatch(clearPurchaseButtonInfo());
          }

          dispatch(
            checkIfProtectPaymentIsActive({
              onSuccess: () => {
                navigate({
                  pathname: link,
                  search: `?${createSearchParams({
                    ...params,
                    groupId: group_id,
                    comeFromEpgTransactions: true,
                  })}`,
                });
              },
            }),
          );
          dispatch(hideEpg());
          dispatch(hideGrid());
          dispatch(hideEpgTransactions());
        }
      }
    },
    [workflowStart?.inProgress, workflowStart?.success],
  );

  const handleSelectOfferPlan = () => {
    setPlanClicked(plan);
    pushBeginCheckoutEvent(plan);
    dispatch(setCurrentPBI(plan));
    dispatch(getWorkflowStart(plan?.linkworkflowstart));
  };

  const handleClickWhatIncludes = () => {
    pushBeginCheckoutEvent(plan);

    if (plan.family === 'grilla_reducida') {
      navigate(
        `/${GetRegion()}/planselect/prepago?${searchParams.toString()}`,
        {
          ...location,
          state: {
            ...location.state,
            groupId: group_id,
          },
        },
      );
    } else {
      navigate(
        `${location.pathname.replace(
          /^(\/.*?\b\/).*$/,
          '$1planselect',
        )}?${searchParams.toString()}`,
        {
          ...location,
          state: {
            ...location.state,
            whatContainsIsShown: true,
            planClicked: plan,
            groupId: group_id,
            comeFromEpgTransactions: true,
          },
        },
      );
    }
    dispatch(hideEpg());
    dispatch(hideGrid());
    dispatch(hideEpgTransactions());
  };

  useEffect(
    () => {
      if (!liveVideoTagRef?.current) return;
      if (!liveVideoTagRef?.current?.paused) {
        liveVideoTagRef?.current?.pause();
      }
    },
    [liveVideoTagRef?.current?.paused],
  );

  return (
    <div className="single-offer__container">
      <div className="single-offer__title-container">
        <p className="single-offer__title">{renderMaxLengthText(title, 53)}</p>
      </div>

      <div className="single-offer__logo-container">
        {logo ? (
          <img src={logo} className={'single-offer__logo'} alt="logo" />
        ) : (
          <span className={'single-offer__logo'} />
        )}
      </div>

      <p className="single-offer__price-container">
        <span className="single-offer__price">
          {renderMaxLengthText(priceText, 10)}
        </span>
        <span className="single-offer__periodicity">
          {renderMaxLengthText(periodicity, 16)}
        </span>
      </p>

      <p className="single-offer__tax">{renderMaxLengthText(tax, 12)}</p>
      <p
        className="single-offer__promo"
        style={{
          color: colorPromotion,
        }}
      >
        {renderMaxLengthText(offer, 38)}
      </p>

      <p className="single-offer__description">
        {renderMaxLengthText(promoMessage, 112)}
      </p>

      <div className="single-offer__buttons-container">
        <button
          className="single-offer__what-includes-button"
          style={{
            backgroundColor: bgColorWhatIncludes,
          }}
          onClick={handleClickWhatIncludes}
        >
          <MultilineText
            text={whatIncludes}
            maxLines={2}
            maxCharsPerLine={20}
          />
        </button>

        <button
          className="single-offer__purchase-button"
          style={{
            backgroundColor: bgColorContract,
          }}
          onClick={() => handleSelectOfferPlan()}
        >
          <MultilineText text={contract} maxLines={2} maxCharsPerLine={20} />
        </button>
        <button
          className="single-offer__cancel-button"
          style={{
            backgroundColor: bgColorCancel,
          }}
          onClick={() => handleExitOrCancel()}
        >
          {renderMaxLengthText(cancel, 20)}
        </button>
      </div>
    </div>
  );
};

export default SingleOfferScreen;
